<script>

    export default {

        name: 'PageHeader',

        data() {
            return {
                scrolled: false,
                toggled: false,
            };
        },

        computed: {
            classes() {
                return {
                    'pageHeader-isFixed': this.scrolled,
                    'pageHeader-isOpen': this.toggled,
                };
            },
        },

        methods: {
            handleScroll() {
                this.scrolled = window.pageYOffset > 5;
            },
            toggleMenu() {
                this.toggled = !this.toggled;
            },
        },

        beforeMount() {
            window.addEventListener('scroll', this.handleScroll);
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },

    };
</script>
